import { ActionTypes } from 'redux/utils/Delete'

export default ActionTypes('USER_MANUAL')